<template>
  <div>
    <div class="news d-none d-md-flex md-elevation-3 mb-md-5 mb-0">
      <div class="front">
        <md-progress-spinner v-if="load" class="md-accent" md-mode="indeterminate"></md-progress-spinner>
        <md-empty-state v-if="!destaks"
                        class="text-white md-primary p-evt-all"
                        md-theme="black"
                        md-icon="check_box_outline_blank"
                        md-label="Está Vazio"
                        md-description="Não há nenhum conteúdo cadastrado!">
        </md-empty-state>
        <md-empty-state v-if="error"
                        class="text-white md-primary p-evt-all"
                        md-theme="black"
                        md-icon="cloud_off"
                        md-label="Não foi possível carregar"
                        md-description="Algum problema aconteceu no carregamento deste bloco, por favor tente novamente.">
          <md-button class="md-primary md-raised">Tentar novamente</md-button>
        </md-empty-state>
        <div v-if="!(load || error || !destaks)" class="container">
          <div class="row mb-3">
            <div class="col-12">
              <h1 class="m-0 p-evt-all md-headline text-primary font-weight-bolder">Destaques</h1>
            </div>
          </div>
          <div class="row p-evt-all d-md-flex d-none">
            <div v-for="destak in destaks" :key="destak._id" class="col-md-4 col-sm-12 col-12">
              <destak-card
                :image="destak.imagemNome"
                :date="destak.data"
                :title="destak.titulo"
                :subtitle="destak.descricao">
              </destak-card>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-sm-12">
              <router-link tag="span" to="noticias">
                <md-button class="p-evt-all md-raised md-primary m-0">Ver Todos os Destaques</md-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="particle">
        <vue-particles class="vue-particles"
                       :particleOpacity="1.0"
                       :particlesNumber="100"
                       :particleSize="4"
                       :linesWidth="2"
                       :moveSpeed="2"
                       :lineOpacity="0.2"
                       linesColor="#111"
                       color="#cc0000"></vue-particles>
      </div>
      <div class="back">
        <!--<img src="../assets/background/bg_lines_connect.png" alt="">-->
      </div>
    </div>
    <div class="d-flex flex-column d-md-none">
      <div class="container">
        <h1 class="m-0 md-headline text-primary mt-2 font-weight-bolder">Destaques</h1>
      </div>
      <carousel :autoplayTimeout="3000" :loop="true" :autoplay="true" :paginationEnabled="false" :perPage="1">
        <slide v-for="destak in destaks" :key="destak._id">
          <md-card class="mt-1 p-2 mb-3" md-theme="black">
            <md-card-header>
              {{destak.titulo}}
            </md-card-header>
            <md-content>
              <destak-card
                class="w-100"
                :image="destak.imagemNome"
                :date="destak.data"
                :title="destak.titulo"
                :subtitle="destak.descricao">
              </destak-card>
            </md-content>
          </md-card>
        </slide>
      </carousel>
      <div class="container mb-3">
        <router-link tag="span" to="noticias">
          <md-button class="p-evt-all md-raised md-primary m-0">Ver Todos os Destaques</md-button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import DestakCard from "./DestakCard";
  import getDestakData from '../scripts/getDestakData'
  import { Carousel, Slide } from 'vue-carousel';

  export default {
    name: "NewsPresentArea",
    components: {DestakCard, Carousel, Slide},
    data() {
      return {
        destaks: [{ _id: "", imagemNome: "", data: new Date(), descricao: "", titulo: "" }],
        load: true,
        error: false
      }
    },
    created() {

      const gdd = getDestakData(3);

      gdd.then(items => {
        this.load = false;

        if(items.length === 0) {
          this.destaks = null;
          return;
        }

        this.destaks = items
      });

      gdd.catch(() => {
        this.load = false;
        this.error = true;
      })

    },
    methods: {
      tryRenew() {
        const gdd = getDestakData(3);

        gdd.then(items => {
          this.load = false;

          if(items.length === 0) {
            this.destaks = null;
            return;
          }

          this.destaks = items
        });

        gdd.catch(() => {
          this.load = false;
          this.error = true;
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .news {
    height: 480px;
    max-height: 1600px;
    display: flex;
    position: relative;
    width: 100%;
   // overflow: hidden;
  }

  .front {
    pointer-events: none;
    position: absolute;
    z-index: 3;
    width: 100%;
    height: 100%;
    //background: radial-gradient(ellipse at center, rgba(0,0,0,0.18) 0%,rgba(0,0,0,0.75) 82%, rgba(0,0,0,0.65) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .p-evt-all {
    pointer-events: all;
  }

  .particle {
    display: flex;
    min-width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2;
    & > .vue-particles {
      object-fit: cover;
      width: 100%;
      height: auto;
    }
  }

  .back {
    display: flex;
    min-width: 100%;
    position: absolute;
    // align-items: flex-start;
    z-index: 1;
    > img {
      object-fit: cover;
      width: 100%;
      height: auto;
    }
  }

</style>
